/**
 * @generated SignedSource<<828d57db2571db8dd643303701ceb12a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDetailActions_memberPackage$data = {
  readonly customer: {
    readonly club: {
      readonly " $fragmentSpreads": FragmentRefs<"useClubIsSellingPackages_club">;
    };
    readonly id: string;
  };
  readonly id: string;
  readonly package: {
    readonly __typename: string;
    readonly name: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CancelPackageModal_memberPackage" | "useShouldShowCancelButton_memberPackage">;
  readonly " $fragmentType": "PackageDetailActions_memberPackage";
};
export type PackageDetailActions_memberPackage$key = {
  readonly " $data"?: PackageDetailActions_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDetailActions_memberPackage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDetailActions_memberPackage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelPackageModal_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowCancelButton_memberPackage"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useClubIsSellingPackages_club"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};
})();

(node as any).hash = "a66b50d70389440f231853b65f8406a0";

export default node;
